import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import MemeEffect from './MemeEffect';
import icon1 from '../assets/icons/icon1.svg';
import icon2 from '../assets/icons/icon2.svg';
import icon3 from '../assets/icons/icon3.svg';
import icon4 from '../assets/icons/icon4.svg';
import icon5 from '../assets/icons/icon5.svg';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #fff;
  border-bottom: 1px solid #000;
  height: 45px; /* 고정 높이 설정 */
  box-sizing: border-box; /* padding과 border를 포함한 높이 계산 */
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
`;

const LogoText = styled(Link)`
  margin-left: 10px;
  font-size: 24px;
  font-weight: normal;
  text-decoration: none;
  color: black;
  font-family: 'Neo둥근모 Pro', sans-serif; /* 폰트 적용 */
`;

const ByText = styled.span`
  font-size: 16px;
`;

const CenterNav = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  gap: 50px;
`;

const Nav = styled.nav`
  display: flex;
  gap: 20px;
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

const NavItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  a, button {
    display: flex;
    align-items: center;
    gap: 5px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    text-decoration: none;
    color: black;
    font-family: 'Neo둥근모 Pro', sans-serif; /* 폰트 적용 */
  }
`;

const Header = () => {
  const location = useLocation();
  const [showMemeEffect, setShowMemeEffect] = useState(false);

  const showButtons = !['/how-to-use', '/about'].includes(location.pathname);

  const handleMemeClick = () => {
    setShowMemeEffect(true);
  };

  const handleReset = () => {
    window.location.reload();
  };

  return (
    <>
      <HeaderContainer>
        <Logo>
          <Icon src={icon1} alt="Logo" />
          <LogoText to="/">풍화 나이테 <ByText>by Changha</ByText></LogoText>
        </Logo>
        {showButtons && (
          <CenterNav>
            <NavItem>
              <button onClick={handleReset}>
                <Icon className="icon" src={icon2} alt="Reset" />
                <span>RESET</span>
              </button>
            </NavItem>
            <NavItem onClick={handleMemeClick}>
              <Icon className="icon" src={icon3} alt="Meme" />
              <span>MEME</span>
            </NavItem>
          </CenterNav>
        )}
        <Nav>
          <NavItem>
            <Link to="/how-to-use">
              <Icon className="icon" src={icon4} alt="How to Use" />
              <span>HOW TO USE</span>
            </Link>
          </NavItem>
          <NavItem>
            <Link to="/about">
              <Icon className="icon" src={icon5} alt="About" />
              <span>ABOUT</span>
            </Link>
          </NavItem>
        </Nav>
      </HeaderContainer>
      {showMemeEffect && <MemeEffect onEffectEnd={() => setShowMemeEffect(false)} />}
    </>
  );
};

export default Header;
